import { useRef } from "react";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import SkillCard from "./SkillCard";
import Figma from "../assets/Figma.svg";
import JavaScript from "../assets/JavaScript.svg";
import TypeScript from "../assets/TypeScript.svg";
import ReactJS from "../assets/React.svg";
import Tailwind from "../assets/Tailwind.svg";
import Git from "../assets/Git.svg";
import Node from "../assets/Node.svg";
import PostgreSQL from "../assets/PostgreSQL.svg";
import Layout from "../assets/Layout.svg";
import Responsive from "../assets/Responsive.svg";
import Interactive from "../assets/Interactive.svg";
import goldenChina from "../assets/GCRestuarant.png";
import dealFlower from "../assets/DealFlower.png";
import Statsify from "../assets/Statsify.png";
import VirtuTrade from "../assets/VirtuTrade.png";
import ProjectCard from "./ProjectCard";

export default function Main({ isMobile, isTablet }) {
  const designSkills = [
    { name: "UI Design", icon: Layout, description: "crafting intuitive interfaces that prioritize user experience", isTech: false },
    { name: "Responsive Design", icon: Responsive, description: "ensuring seamless user experience across all screen sizes and devices", isTech: false },
    { name: "Interactive Design", icon: Interactive, description:"building engaging elements that elevate user interaction", isTech: false },
  ]
  const techSkills = [
    { name: "Figma", icon: Figma, description: "design tool", isTech: true },
    { name: "HTML CSS JavaScript", icon: JavaScript, description: "the foundation stack", isTech: true },
    { name: "React", icon: ReactJS, description: "JavaScript library", isTech: true },
    { name: "Tailwind", icon: Tailwind, description: "CSS framework", isTech: true },
    { name: "TypeScript", icon: TypeScript, description: "superset of JavaScript", isTech: true },
    { name: "Git", icon: Git, description: "version control", isTech: true },
  ];
  const projects = [
    {name: 'VIRTU TRADE', role: "Personal Project | 2025", description: "Developed a web app for crypto paper trading that allows users to simulate buying and selling digital assets, track portfolio performance, and practice strategies in a risk-free environment", tech: [ReactJS, Tailwind, Node, PostgreSQL], techName: ["React", "TailwindCSS", "Node.js", "PostgreSQL"],image: VirtuTrade, link: 'https://virtu-trade.jasonzhang.studio'},
    {name: 'STATSIFY', role: "Personal Project | 2024", description: "Created a web app using Spotif's API to deliver personalized listening stats across three time spans: 4 weeks, 6 months, and all-time, on a clean and user-friendly interface", tech: [Figma, ReactJS, Tailwind, Node], techName: ["Figma", "React", "TailwindCSS", "Node.js"], image: Statsify, link: 'https://statsify.jasonzhang.studio', sourceCode: 'https://github.com/jasonyjzhang/statsify'},
    {name: 'GC RESTAURANT', role: "Local Business | 2024", description: 'Worked with a local small business to create an online website that allows customers to easily navigate the menu, discover new specials, and access basic store information', tech: [Figma, ReactJS, Tailwind], techName: ["Figma", "React", "TailwindCSS"], image: goldenChina, link: 'https://goldenchina.xyz'},
    {name: 'DEAL FLOWER', role: "Startup Concept | 2023", description: 'Collaborated with a small group of software engineers to attempt a startup concept: develop an online platform that allows users to monitor the social media activities of venture capitalists they choose to track', tech: [Figma, ReactJS, Tailwind], techName: ["Figma", "ReactJS", "TailwindCSS"], image: dealFlower, link: 'https://jasonyjzhang.github.io/deal_flower_launch', sourceCode: 'https://github.com/jasonyjzhang/deal_flower_launch'},
  ]
  const designSkillsRef = useRef(null),
        devSkillsRef = useRef(null),
        projectsRef = useRef(null);
  useGSAP(() => {
    const groupList = [...designSkillsRef.current.children, ...devSkillsRef.current.children];
    groupList.forEach((element) => {
      gsap.from(element, {
        y: 30,
        opacity: 0,
        scrollTrigger: {
          trigger: element,
          start: "center 80%",
        },
        duration: 2,
        ease: "power4.out",
      });
    });
  }, []);
  return (
    <div className={`bg-black flex justify-center`}>
      <div className={`flex flex-col lg:w-[1100px] my-24 mx-[1rem]`}>
        <h1 className={`text-white text-2xl font-semibold`}>Design + Development</h1>
        <div ref={designSkillsRef} className={`grid md:grid-cols-2 lg:grid-cols-3 gap-4 mt-8`}>
          {
            designSkills.map((skill, index) => {
              return <SkillCard key={index} name={skill.name} icon={skill.icon} description={skill.description} isTech={skill.isTech} />
            })
          }
        </div>
        <h1 className={`text-white text-2xl font-semibold mt-24`}>My Tech Stack</h1>
        <div ref={devSkillsRef} className={`grid md:grid-cols-2 lg:grid-cols-3 gap-4 mt-8`}>
          {
            techSkills.map((skill, index) => {
              return <SkillCard key={index} name={skill.name} icon={skill.icon} description={skill.description} isTech={skill.isTech} />
            })
          }
        </div>
        <h1 className={`text-white text-2xl font-semibold mt-24`}>Selected Works</h1>
        <div ref={projectsRef} className={`flex flex-col mt-8 space-y-8`}>
          {
            projects.map((project, index) => {
              return <ProjectCard ref={`project${index}`} key={index} name={project.name} image={project.image} role={project.role} description={project.description} tech={project.tech} techName={project.techName} link={project.link} sourceCode={project.sourceCode} isMobile={isMobile} isTablet={isTablet}/>
            })
          }
        </div>
      </div>
    </div>
  )
};